import { useEffect, useState, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { supabase } from '@/lib/supabaseClient';
import { toast } from 'sonner';

// ============================================================
// TIPOS
// ============================================================

export interface CategoriaEmpresa {
  id_categoria: string;
  categoria: string;
}

// ============================================================
// HOOK PRINCIPAL
// ============================================================

export const useCategoriasEmpresa = () => {
  const [categorias, setCategorias] = useState<CategoriaEmpresa[]>([]);
  const [loadingCategorias, setLoadingCategorias] = useState(false);
  const [errorCategorias, setErrorCategorias] = useState<string | null>(null);

  // ============================================================
  // Obtener categorías
  // ============================================================
  const fetchCategorias = useCallback(async () => {
    setLoadingCategorias(true);
    setErrorCategorias(null);

    const { data, error } = await supabase
      .from('vista_cb_categoria_empresa')
      .select('id_categoria, categoria')
      .order('categoria', { ascending: true });

    if (error) {
      Sentry.captureException(error); // 👈
      setErrorCategorias('Error al cargar categorías');
      toast.error('No se pudieron cargar las categorías');
      setLoadingCategorias(false);
      return;
    }

    setCategorias(data || []);
    setLoadingCategorias(false);
  }, []);

  // ============================================================
  // Cargar automáticamente al montar
  // ============================================================
  useEffect(() => {
    fetchCategorias();
  }, [fetchCategorias]);

  // ============================================================
  // RETURN
  // ============================================================
  return {
    categorias,
    loadingCategorias,
    errorCategorias,
    refetchCategorias: fetchCategorias,
  };
};
